import { render } from "./QuoteDetailForm.vue?vue&type=template&id=6e4733bc&scoped=true"
import script from "./QuoteDetailForm.vue?vue&type=script&lang=js"
export * from "./QuoteDetailForm.vue?vue&type=script&lang=js"

import "./QuoteDetailForm.vue?vue&type=style&index=0&id=6e4733bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4733bc"]])

export default __exports__